import styled from 'styled-components';

import {
  Flex,
  icons,
} from 'web-styled';

export const Videos = styled(Flex).attrs({
  column: true,
  spacing: 20,
})`
  width: 100%;
  min-height: 350px;
`;

export const Starting = styled(Flex).attrs({
  column: true,
  spacing: 15,
  align: 'center',
})`
  width: 100%;
  min-height: 350px;
  text-align: center;
`;

export const StartIcon = styled.div`
  background-image: url(${icons.startVideoSearch});
  margin-top: 5%;
  margin-left: 18%;
  width: 164px;
  height: 137px;
  background-size: cover;
`;
